<div class="media-viewer" *ngIf="media">
  @let src = media.links?.[0]?.src;
    <!-- <span>{{media.type+': [source: '+src+']'}}</span> -->
    <div class="media-content" [ngSwitch]="media.type">
      <ng-container *ngSwitchCase="'image'">
        <img [src]="src | serverAuthUrl" [alt]="media.name" class="img-fluid" />
        <!-- PDFs get a download button from the PDF viewer's toolbar; an image
             has no toolbar of its own, so without this a member could only
             right-click or long-press the picture. Only for media that declare
             download: true, the same flag that puts the icon on the tile. -->
        @if (downloadable()) {
          <ng-container *ngTemplateOutlet="downloadButtonTemplate"></ng-container>
        }
      </ng-container>
      <!-- <ng-container *ngSwitchCase="'video', 'audio'">
        <video-player #videoPlayer [media]="media" [autoplay]="true"></video-player>
        <div *ngIf="toolbarDisplayed()" [@fadeInOut]="{ value:':enter,:leave', params:  animationTimings.fadeInOut}"
          class="toolbar">
          <div class="actions">
            <ng-container *ngFor="let action of media.actions">
              <div (click)="onTapAction(action)" class="action">
                <ng-container *ngTemplateOutlet="actionTemplate; context: { action: action }"></ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container> -->

      <ng-container *ngSwitchCase="'video'">
        <ng-container *ngTemplateOutlet="videoPlayerTemplate; context: { media }"></ng-container>
        <!-- Same button as for images (explorer videos declare download: true).
             It sits outside <video-player>, so it is not part of the player's
             own fullscreen and never covers the control bar at the bottom. -->
        @if (downloadable()) {
          <ng-container *ngTemplateOutlet="downloadButtonTemplate"></ng-container>
        }
      </ng-container>
      
      <ng-container *ngSwitchCase="'audio'">
        <ng-container *ngTemplateOutlet="videoPlayerTemplate; context: { media }"></ng-container>
      </ng-container>

      <ngx-extended-pdf-viewer *ngSwitchCase="'pdf'" [src]="src | serverAuthUrl" [authorization]="true"
        [height]="'100%'" [showHandToolButton]="true" [showDownloadButton]="true" [showPrintButton]="true"
        [showOpenFileButton]="false" [theme]="theme" [language]="i18nService.getLanguage()">
      </ngx-extended-pdf-viewer>
      <ng-container *ngSwitchCase="'conference'">
        @if (media.type == 'conference') { <!-- required for type narrowing -->
          @if (media.properties?.['conference']?.tags?.includes('zoom')) {
            <conference-zoom [media]="media" (onClose)="close()"></conference-zoom>
          } @else {
            <conference-jitsi [media]="media" (onClose)="close()"></conference-jitsi>
          }
        }
        <!-- <conference-jitsi *ngIf="media.type == 'conference'" [conference]="media" (onClose)="close()"></conference-jitsi> -->
      </ng-container>
      <ng-container *ngSwitchCase="'eap'">
        <iframe [src]="src | serverAuthUrl | safeUrl" class="eap-iframe" [title]="media.name" frameborder="0" (error)="onIframeError($event)">
        </iframe>
      </ng-container>
      <span *ngSwitchDefault>{{media.type}} not supported</span>
    </div>
</div>

<ng-template #videoPlayerTemplate let-media="media">
  <video-player #videoPlayer [media]="media" [autoplay]="true"></video-player>
  <div *ngIf="toolbarDisplayed()" [@fadeInOut]="{ value:':enter,:leave', params:  animationTimings.fadeInOut}"
    class="toolbar">
    <div class="actions">
      <ng-container *ngFor="let action of media.actions">
        <div (click)="onTapAction(action)" class="action">
          <ng-container *ngTemplateOutlet="actionTemplate; context: { action: action }"></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #downloadButtonTemplate>
  <button type="button" cButton color="primary" class="download-button" (click)="download()">
    <svg cIcon name="cisCloudDownload"></svg>
    <span>{{ 'media.explorer.download' | translate }}</span>
  </button>
</ng-template>

<ng-template #actionTemplate let-action="action">
  <button cButton color="primary">
    @if (action.icon) {
    <svg cIcon [name]="action.icon"></svg>
    }
    <span *ngIf="action.label">{{action.label | translate}}</span>
    <span *ngIf="!action.label">{{'media.actions.'+action?.id | translate}}</span>
  </button>
</ng-template>